import AbstractTrack from 'common/services/doxy-analytics/abstract.track';
import { RootScopeEvents } from 'common/services/root-scope-types';
export default class MeetingHistoryTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'meeting history';
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.ANALYTICS.MEETING_HISTORY, ($e, data) => {
            this.trackButtonEventSegment(data);
        });
    }
}
